/*
 */
const allKeys =
    "0123456789abcdefghigklmnopqrstuvwxyzABCDEFGHIGKLMNOPQRSTUVWXYZ";
const upperKeys = "0123456789ABCDEFGHIGKLMNOPQRSTUVWXYZ";

const allKeysBuilder = (key: string) => () =>
    key.replace(/\*/g, () => allKeys[(Math.random() * 62) | 0]);

export const uuid4 = allKeysBuilder("**-**");

export const uuid6 = allKeysBuilder("***-***");
